import { Heading, Icon, ModalBox, useFocus, useMediaQueryContext, useModalContext, } from '@fourthwall/components';
import { ArrowShortLeftIcon, CloseIcon } from '@fourthwall/icons';
import { routing } from '@utils/routing';
import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import * as S from './AddSubscriptionModal.styled';
import { IntroStage } from './components/IntroStage/IntroStage';
import { PaymentStage } from './components/PaymentStage/PaymentStage';
import { SelectPlanStage } from './components/SelectPlanStage/SelectPlanStage';
import { Slider } from './components/Slider/Slider';
import { SuccessStage } from './components/SuccessStage/SuccessStage';
import { usePlans } from './hooks/usePlans';
import { useStage } from './hooks/useStage';
export const AddSubscriptionModal = ({ title = 'Upgrade to Fourthwall Pro', initialPlanId, initialStage, showSuccessScreen = false, onSuccess, }) => {
    const { close, open } = useModalContext();
    const media = useMediaQueryContext();
    const navigate = useNavigate();
    const { stage, canGoToPreviousStage, goToPreviousStage, goToNextStage } = useStage(initialStage);
    const { plans, selectedPlan, setSelectedPlan } = usePlans(initialPlanId);
    const [closeButtonRef, setCloseButtonFocus] = useFocus();
    const showSlider = useMemo(() => {
        if (media.tablet) {
            return stage !== 'SUCCESS';
        }
        return stage === 'INTRO';
    }, [media.tablet, stage]);
    const showHeader = stage !== 'SUCCESS';
    const handleAddPaymentMethodClose = () => {
        open(AddSubscriptionModal, {
            title,
            initialPlanId: selectedPlan?.id,
            initialStage: 'PAYMENT',
            showSuccessScreen,
            onSuccess,
        });
    };
    const handlePaymentSuccess = () => {
        if (!showSuccessScreen) {
            close();
            onSuccess?.();
            return;
        }
        goToNextStage();
    };
    const handleOrderSamples = () => {
        navigate(routing.settings.samples.order);
        close();
        onSuccess?.();
    };
    useEffect(() => {
        setCloseButtonFocus();
    }, []); // make sure it's an empty array
    return (React.createElement(ModalBox, { width: media.tablet ? '930px' : undefined, fullWidth: !media.tablet, onClose: close, withoutPadding: true, withoutCloseButton: true },
        React.createElement(S.Container, null,
            React.createElement(S.CloseButton, { "aria-label": "Close", type: "button", ref: closeButtonRef, variant: stage === 'SUCCESS' ? 'dark' : 'light', onClick: close },
                React.createElement(Icon, { component: CloseIcon, height: media.tablet ? 16 : 12 })),
            React.createElement(S.MainContent, null,
                showHeader && (React.createElement(S.HeaderContainer, null,
                    canGoToPreviousStage && (React.createElement(S.BackButton, { "aria-label": "Back", type: "button", onClick: goToPreviousStage },
                        React.createElement(Icon, { component: ArrowShortLeftIcon, height: 12 }))),
                    React.createElement(Heading, { type: "h6", weight: "semibold" }, title))),
                stage === 'INTRO' && React.createElement(IntroStage, { onNext: goToNextStage }),
                stage === 'SELECT_PLAN' && (React.createElement(SelectPlanStage, { plans: plans, selectedPlanId: selectedPlan?.id, onPlanSelect: setSelectedPlan, onContinue: goToNextStage })),
                stage === 'PAYMENT' && (React.createElement(PaymentStage, { total: selectedPlan?.totalPrice, onSuccess: handlePaymentSuccess, onAddPaymentMethodClose: handleAddPaymentMethodClose })),
                stage === 'SUCCESS' && (React.createElement(SuccessStage, { onOrderSamples: handleOrderSamples, onClose: close }))),
            showSlider && (React.createElement(S.SidebarContent, null,
                React.createElement(Slider, null))))));
};
